export type PrecursorCnCodeSourceGroupsPathTarget = {
  installationId: string
  precursorCnCodeId: string
}

export function precursorCnCodeSourceGroupsPath({
  installationId,
  precursorCnCodeId,
}: PrecursorCnCodeSourceGroupsPathTarget) {
  return `/dashboard/${installationId}/installation/configuration/precursor-cn-codes/${precursorCnCodeId}/source-groups`
}
